module.exports = __webpack_public_path__ + "img/videoIcon.ba45d69b.svg";